export const DEBUG = true;
export const APP_ENV = 'DEV';
export const PROTOCOL = 'http';
export const API = {}

export const CONSTANTS = {
  LOCAL_STORAGE_LANG_KEY: 'RS_LANG_KEY',
  LANGUAGES: [
    {
      key: 'en',
      name: 'english'
    },
    {
      key: 'fr',
      name: 'french'
    }
  ],
}
